import type {
  InputMaybe,
  MetadataFilterInput,
  MetadataGroupByInput,
  MetadataSortByInput,
} from '@frameio/graphql-client/generated';
import {
  isQueryGetCollectionAssets,
  isQueryGetFinderItems,
  isQueryGetFolderAssets,
  isQueryGetShareAssets,
  type PossibleFinderQuery,
} from './shared';

/** given a finder observable query, return the field definition ids relevant to its ordering  */
export const getOrderingDefinitionIds = (query: PossibleFinderQuery) => {
  const ids: string[] = [];
  let filters:
    | InputMaybe<MetadataFilterInput | MetadataFilterInput[]>
    | undefined;
  let sorts:
    | InputMaybe<MetadataSortByInput | MetadataSortByInput[]>
    | undefined;
  let groups:
    | InputMaybe<MetadataGroupByInput | MetadataGroupByInput[]>
    | undefined;

  if (isQueryGetFinderItems(query)) {
    filters = query.variables?.filters;
    sorts = query.variables?.sortBys;
    groups = query.variables?.groupBys;
  } else if (isQueryGetCollectionAssets(query)) {
    filters = query.variables?.query?.filter;
    sorts = query.variables?.query?.sortBy;
    groups = query.variables?.query?.groupBy;
  } else if (isQueryGetShareAssets(query)) {
    sorts = query.variables?.sortBys;
  } else if (isQueryGetFolderAssets(query)) {
    sorts = query.variables?.sortBy;
  }

  if (filters && Array.isArray(filters)) {
    filters.forEach((filter) => {
      ids.push(filter.fieldDefinitionId);
    });
  }
  if (filters && !Array.isArray(filters)) {
    ids.push(filters.fieldDefinitionId);
  }

  if (sorts && Array.isArray(sorts)) {
    sorts.forEach((sort) => {
      ids.push(sort.fieldDefinitionId);
    });
  }
  if (sorts && !Array.isArray(sorts)) {
    ids.push(sorts.fieldDefinitionId);
  }

  if (groups && Array.isArray(groups)) {
    groups.forEach((group) => {
      ids.push(group.fieldDefinitionId);
    });
  }
  if (groups && !Array.isArray(groups)) {
    ids.push(groups.fieldDefinitionId);
  }

  return ids;
};
